import React from 'react'
import {
  ButtonPrimaryV2,
  CardContent,
  colors2,
  LoaderOverlay,
  MetaBlock,
  Modal,
  SkeletonLoader,
  TextInput,
  UI_BODY_DF,
  UI_DISPLAY,
  WrapperCardGrid,
} from "oolib";
import { useCreateReport, useGetAllReports } from "../ReportLanding/queries";
import { useLocation, useNavigate } from "react-router-dom";
import { Fragment, useState } from "react";
import { useGetQueryData } from '@/utils/react-query-hooks/general';
import { CreateNewCard } from './comps/CreateNewCard';
import { parseSpecialConfigSyntax } from "@okf/ootils";
import { getTenant } from "@/TENANT_CONFIGS";
import { isFeatureDisabledOnProd } from "@/utils/isFeatureDisabledOnProd";

const CreateModal = ({ setShowCreateModal, createReport, navigate }) => {
  const [title_subtitle, setTitleSubtitle] = useState({
    title: "",
    subtitle: "",
  });
  const {SELF_MANAGED_BASE_CONFIGS} = useGetQueryData('platformConfigs')
  return (
    <Modal
      onClose={() => setShowCreateModal(false)}
    >
      <div
        style={{
          padding: "1.6rem",
          display: "flex",
          flexDirection: "column",
          gap: "1.2rem",
        }}
      >
        <TextInput
          isRequired={true}
          label="Title"
          onChange={(k, v) =>
            setTitleSubtitle((prev) => ({ ...prev, title: v }))
          }
          value={title_subtitle.title}
        />
        <TextInput
          label="Subtitle"
          onChange={(k, v) =>
            setTitleSubtitle((prev) => ({ ...prev, subtitle: v }))
          }
          value={title_subtitle.subtitle}
        />
        <ButtonPrimaryV2
          disabled={!title_subtitle.title}
          onClick={() => {
            createReport(
              {
                type: "customDashboard",
                title: title_subtitle.title,
                subtitle: title_subtitle.subtitle,
              },
              {
                onSuccess: (res) => {
                  navigate(
                    parseSpecialConfigSyntax({
                      config: SELF_MANAGED_BASE_CONFIGS?.reports?.linkToViewReport || `/reports/view/${res.data._id}`,
                      content: { _id: res.data._id}
                    })
                  );
                },
              }
            );
          }}
        >
          Create Report
        </ButtonPrimaryV2>
      </div>
    </Modal>
  );
};

export const ReportsListing = () => {
  const { data, status } = useGetAllReports();
  const navigate = useNavigate();
  const { mutate: createReport, isLoading } = useCreateReport();
  // `?create=1` lands with the create modal already open — the Overview's
  // "Create a Report" link, shown when there are no reports yet. Read once.
  const location = useLocation();
  const [showCreateModal, setShowCreateModal] = useState(() => new URLSearchParams(location.search).get("create") === "1");
  const platformConfigs = useGetQueryData('platformConfigs')
  const { SELF_MANAGED_BASE_CONFIGS } = platformConfigs || {}

  // In collab (always-live) mode published/unpublished status stops mattering,
  // so the status tag on the listing cards is just noise — hide it. Same gate
  // as the rest of report-collab (on off-prod, off on prod).
  const reportCollabEnabled = !isFeatureDisabledOnProd("reportCollabEditing", {
    disabledFeatures: platformConfigs?.FEATURES_DISABLED_ON_PROD || [],
    isProd: import.meta.env.VITE_ENV === "prod",
    tenant: getTenant(),
  })

  return (
    <Fragment>
        {isLoading && <LoaderOverlay loaderText='Creating Report...'/>}
      {showCreateModal && (
        <CreateModal
          setShowCreateModal={setShowCreateModal}
          createReport={createReport}
          navigate={navigate}
        />
      )}
      <div style={{ padding: "1.6rem" }}>
        <WrapperCardGrid>
          {status === "loading" ? (
            [1, 2, 4, 5, 6, 7, 8].map((d) => (
              <SkeletonLoader
                style={{ height: "30rem", borderRadius: "1.4rem" }}
              />
            ))
          ) : (
            <Fragment>
              <CreateNewCard
                text='Create a New Report'
                onClick={() => {
                  setShowCreateModal(true);
                }}
                />
              {data?.map((d) => (
                <CardContent
                  data={d}
                  onClick={() => navigate(
                    parseSpecialConfigSyntax({
                      config: SELF_MANAGED_BASE_CONFIGS?.reports?.linkToViewReport || `/reports/view/${d._id}`,
                      content: d
                    })
                  )}
                  config={{
                    title: "title",
                    desc: 'subtitle',
                    cardLabel: reportCollabEnabled ? undefined : "status",
                    image: 'path.doesnt.exist',
                    metaBlock: [
                      { key: "name", valuePath: "author.name" },
                      { key: "date", valuePath: "dateLastEdited" },
                    ],
                  }}
                />
              ))}
            </Fragment>
          )}
        </WrapperCardGrid>
      </div>
    </Fragment>
  );
};
